<div class="taxation-info-container">
    <span class="taxation-info-position">{{ grossTitle }}</span>
    <span class="taxation-info-right-position">{{ grossAmount }}</span>
</div>
<div class="taxation-info-container">
    <span class="taxation-info-position">{{ taxTitle }}</span>
    <span class="taxation-info-position">-{{ tax }}</span>
</div>
<div class="taxation-info-container">
    <span class="taxation-info-position">{{ netTitle }}</span>
    <span class="taxation-info-right-position">{{ netAmount }} </span>
</div>
